export const INVITE_USER_NAME = "invite_user" as const;

export const INVITE_USER_DESC = `Invites one or more users to the current workspace via the sendInvitation mutation.

Use when the user asks to invite/add members to a workspace.
This is a write operation, so always require confirmation before execution.
Use the localized role labels returned in the tool output instead of hard-coded language-specific labels.

Input:
- 'organizationId' (optional): The server binds this to the active authorized chat workspace.
- 'invitations' (required): One or more invitations to send in a single batch. Each item requires 'email' and 'role'. Assignable role values are OWNER, ADMINISTRATOR, FULL_MEMBER, and GUEST.

Output:
- Returns per-invitation result fields including 'email', 'role', localized 'roleLabel', success/error details, a batch summary, and settings navigation helpers ('settingsPath'/'settingsUrl').`;
